import { render, staticRenderFns } from "./problemCheckTask.vue?vue&type=template&id=4ee7aa39&scoped=true&"
import script from "./problemCheckTask.vue?vue&type=script&lang=js&"
export * from "./problemCheckTask.vue?vue&type=script&lang=js&"
import style0 from "./problemCheckTask.vue?vue&type=style&index=0&id=4ee7aa39&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee7aa39",
  null
  
)

export default component.exports